import About from './about.vue'
import Beat from './beat.vue'
import Beats from './beats.vue'
import Charts from './charts.vue'
import Checkout from './checkout.vue'
import Contact from './contact.vue'
import Discover from './discover.vue'
import Licenses from './licenses.vue'
import Order from './order.vue'
import Search from './search.vue'
import Song from './song.vue'
import Songs from './songs.vue'
import SoundKit from './soundkit.vue'
import Services from './services.vue'
import Service from './service.vue'
import SoundKits from './soundkits.vue'
import BeatTapes from './beat-tapes.vue'
import BeatTape from './beat-tape.vue'
import Quotation from './quotation.vue'

import Orders from './orders.vue'
import OrderDetails from './order-details.vue'
export {
    About,
    Beat,
    Beats,
    Charts,
    Checkout,
    Contact,
    Discover,
    Licenses,
    Order,
    Search,
    Song,
    Songs,
    SoundKit,
    SoundKits,
    Services,
    Service,
    Orders,
    OrderDetails,
    BeatTapes,
    BeatTape,
    Quotation
}

export function generateRouteFromPage(page) {
    function getComponent(type) {
        switch (type) {
            case 'discover':
                return Discover;
            case 'beats':
                return Beats;
            case 'songs':
                return Songs;
            case 'soundkits':
                return SoundKits;
            case 'beattapes':
                return BeatTapes;
            case 'services':
                return Services;
            case 'charts':
                return Charts;
            case 'licenses':
                return Licenses;
            case 'beat':
                return Beat;
            case 'song':
                return Song;
            case 'soundkit':
                return SoundKit;
            case 'service':
                return Service;
            case 'contact':
                return Contact;
            case 'about':
                return About
        }
    }

    return  {
        path: page.link,
        name: page.id,
        props: {
            pageId: page.id
        },
        meta: {
            type: page.type,
            pageName: page.name,
        },
        component: getComponent(page.type)
    };
}
